/**
 * Navigation utilities for challenge session routing
 */

/**
 * Get the challenge session path for V2
 * @param {string} challengeId - The challenge UUID
 * @returns {string} The path to navigate to
 */
import { createLogger } from './logger'

const logger = createLogger('navigation')

export const getChallengeSessionPath = (challengeId) => {
  if (!challengeId) {
    logger.warn('getChallengeSessionPath called without challengeId')
    return '/challenge-type'
  }
  return `/challenge-session/${challengeId}`
}

/**
 * Check if a pathname is a challenge session path
 * @param {string} pathname - The current location pathname
 * @returns {boolean} True if it's a challenge session path
 */
export const isChallengeSessionPath = (pathname) => {
  return pathname.startsWith('/challenge-session/')
}
